import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Grid } from "@mui/material";
import { Button } from "@mui/base";
import CommonDialog from "components/commonDialog/CommonDialog";
import SuccessDialog from "components/successDialog/SuccessDialog";
import OtpDialog from "components/otpDialog/OtpDialog";
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import CommonMultiImageForm from "components/commonMultiImageForm/CommonMultiImageForm";

function SubBreadCrumb({
  subButtonText,
  formData,
  type,
  onSubmittBtn,
  name,
  defaultValues,
  onImageChange,
  showOtherComponent,
  closeUploadCompliance,
  cityLocation,
  tabType,
}) {
  const [open, setOpen] = useState(false);
  const [otpDialog, setOtpDialog] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);
  const role = localStorage.getItem("role");
  const { state } = useLocation();
  const { status, companyName } = state;

  const addButton = () => {
    setOpen(true);
    closeUploadCompliance();
  };
  const handleClose = () => {
    setOpen(false);
    setOtpDialog(false);
    setSuccessDialog(false);
  };
  const onDialog = (data, code) => {
    onSubmittBtn(data, code);
    if (type === "Vehicle") {
      setOpen(true);
    } else {
      setOpen(false);
    }
    setOtpDialog(false); //should be true for otp verification
  };

  const onOtpButton = () => {
    setOtpDialog(false);
    setSuccessDialog(false);
  };

  const breadcrumbPaths =
    role === "adminCompany"
      ? [
          {
            name: "City Manager",
            url: "/vendor",
            className: "colorGrey fontSemi",
          },
          {
            name: cityLocation,
            url: "/vendor",
            className: "colorGrey fontSemi",
          },
          { name: companyName || name, url: "", className: "colorBlue" },
        ]
      : [
          {
            name: "Sub-Vendor",
            url: "/subvendor",
            className: "colorGrey fontSemi",
          },
          { name: companyName || name, url: "", className: "colorBlue" },
        ];

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="marginBlock10"
      >
        <Grid item>
          {tabType === "dashboard" && role === "adminCompany" ? null : (
            <CommonBreadCrumb paths={breadcrumbPaths} />
          )}
        </Grid>

        <Grid
          item
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={2}
          xs={5}
        >
          <Grid item>
            {status === "Active" && subButtonText ? (
              <Button
                onClick={() => {
                  addButton();
                }}
                className="btnSubvendor"
              >
                {subButtonText}
              </Button>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
      {type === "Vehicle" && (
        <CommonMultiImageForm
          open={open}
          handleClose={handleClose}
          formData={formData}
          button={"dialogButton"}
          onSubmittBtn={onDialog}
          selectType={"Create"}
          type={type}
          defaultValues={defaultValues}
          onImageChange={onImageChange}
          setOpen={false}
          showOtherComponent={showOtherComponent}
          tabName={'vehicle'}
        />
      )}

      {open && type !== "Vehicle" && (
        <CommonDialog
          open={open}
          handleClose={handleClose}
          formData={formData}
          button={"dialogButton"}
          onSubmittBtn={onDialog}
          selectType={"Create"}
          type={type}
          defaultValues={defaultValues}
        />
      )}
      {otpDialog && (
        <OtpDialog
          open={otpDialog}
          handleClose={handleClose}
          onSubmittBtn={onOtpButton}
        />
      )}
      {successDialog && (
        <SuccessDialog
          open={successDialog}
          handleClose={handleClose}
          type={type}
        />
      )}
    </div>
  );
}

export default SubBreadCrumb;
